/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRecordMail = createReactComponent("outline", "record-mail", "IconRecordMail", [["path", { "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-0" }], ["path", { "d": "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M7 15l10 0", "key": "svg-2" }]]);

export { IconRecordMail as default };
//# sourceMappingURL=IconRecordMail.mjs.map
